import template from './settings.html';
import controller from './settings.controller';

const checkinSettingsComponent = {
  restrict: 'E',
  controller,
  template
};

export default checkinSettingsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/checkin/settings/settings.component.js
 **/